export default __webpack_public_path__ + "static/defaultCoverIntegrations-2769e57dc7f696ea0c709dffcb3d469f.png";